import { Trans } from "@lingui/macro";
import { UiModule } from "@smp/ui";

import { ProviderStickers } from "./context";
import { Filters } from "./screens/filters";
import { StickerDialog } from "./screens/sticker_dialog";
import { Viewport } from "./screens/viewport";

export const Stickers = ({ pathPattern }: { pathPattern: string }) => (
  <ProviderStickers pathPattern={pathPattern}>
    <UiModule
      forceSecondaryDrawer
      isSidebarForceOpen
      disableSecondaryAwayClick
      ScreenMain={
        <>
          <Viewport />
          <StickerDialog />
        </>
      }
      ScreenSecondary={<Filters />}
      ScreenSecondaryDrawerLabel={<Trans>templates.filters.Show filters</Trans>}
    />
  </ProviderStickers>
);
